import get from 'lodash/get';

const needRenderTaxiTypeTNC = (countryCode, serviceType) => {
  const taxiTypeInfo = get(serviceType, 'taxiTypeInfo');
  return countryCode === 'VN' && !!taxiTypeInfo && taxiTypeInfo !== '<nil>';
};

export default needRenderTaxiTypeTNC;
